<template>
  <div class="ccui-error-404-main">
    <div class="ccui-error-404__pic">
      <img
        src="@/assets/404_images/404-new.png"
        alt="404"
        width="572px"
        height="344px"
      />
    </div>
    <div class="ccui-error-404-detail">
      <div class="ccui-error-404-detail-top">404</div>
      <div class="ccui-error-404-detail-text">
        哎呀，网络开小车了，先看看其他页面。
      </div>
      <div class="ccui-error-404-detail-button">
        <el-button type="primary" @click="goBack">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "error404",
  methods: {
    goBack() {
      window.location.href = this.$addUrlPerFix(process.env.VUE_APP_BASEP_URL);
    },
  },
};
</script>
